import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormlyFieldConfig } from 'ng-formly';
import { LoopBackFilter, Entityrecord, } from '../../../sdk/models';
import { AccountApi, EntityApi, EntityfieldApi, EntityrecordApi, } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { EntityService } from '../../../services/entity.service';
import { ValidationService } from '../../../services/validation.service';
import { PlatformApp } from '../../../services/app.service';
import { WindowRef } from '../../../services/window.service';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'table-display',
    templateUrl: './table-display.component.html',
    providers: [EntityApi, EntityfieldApi, EntityrecordApi, EntityService, NotificationsService, PushNotificationsService],
    styleUrls: ['./table-display.component.scss']
})

export class TableDisplayComponent implements OnInit, OnDestroy {
    @Input() entitytype: string;
    @Input() title: string;
    @Input() sortable: string = "false";
    @Input() inputentityid: string;
    @Input() searchlayoutid: string;
    @Input() parentId: string;
    @Input() showCardWrapper: string;

    rows: Array<any> = [];
    columns: Array<any> = [];
    page: number = 1;
    itemsPerPage: number = 10;
    maxSize: number = 5;
    numPages: number = 1;
    length: number = 0;

    config: any = {
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
    };

    records: Array<any> = [];

    gridwidth = '100%';
    calcgridheight = '500px';
    showGrid = true;
    showError = false;
    gridOptions: any;
    subscriptions: any = [];
    entity: any;
    entityid: any;
    entityRecord: any = {};
    entityname = '';
    rowData: any;
    geoFieldName: any;
    columnDefs: any;
    entityDataFields: any;
    currentuser: any;
    formfields: any = [];
    entityrecordid: any = '';
    entityrecordname: any = '';
    topbuttonsOn = true;
    refreshtime;
    notifyOptions = PlatformApp.getNotificationOptions();

    // Form Related
    initialFormData: any;
    formErrors = [];
    formValid = false;
    options: any = {};
    quickFilter = '';

    //filter options
    lookupmap: any;
    /****Formly ***/
    form: FormGroup;
    // form: FormGroup;
    author;
    env;

    events: any[] = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    gridSortModel;
    gridFilterModel;
    status = { isopen: false };

    /****************Modals************************* */
    @ViewChild('newModal') newModal: ModalDirective;
    @ViewChild('editModal') editModal: ModalDirective;
    // @ViewChild('peekModal') peekModal: ModalDirective;
    @ViewChild('confirmModal') confirmModal: ModalDirective;


    constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private winRef: WindowRef,
        private _EntityApi: EntityApi, private _EntityfieldApi: EntityfieldApi,
        private _Account: AccountApi, private _EntityrecordApi: EntityrecordApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _LoopBackAuth: LoopBackAuth, private _EntityService: EntityService,
        private _PlatformApp: PlatformApp) {
        this.length = this.records.length;
    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.refreshData();
    }

    confirmDelete(entityrecord) {
        this.entityRecord = entityrecord;
        if (!this.entityrecordid || (entityrecord.id && this.entityrecordid !== entityrecord.id)) {
            this.entityrecordid = entityrecord.id;
        }
        this.confirmModal.show();
    }

    deleteRecord(entityrecord?): void {
        this.confirmModal.hide();
        if (!this.entityrecordid || (this.entityRecord.id && this.entityRecord.id !== this.entityrecordid)) {
            this.entityrecordid = this.entityRecord.id;
        }

        let eid = this.entityrecordid;
        if (!eid && entityrecord) { eid = entityrecord.id; }

        this.subscriptions.push(this._EntityrecordApi.deleteById(eid)
            .subscribe((result) => {
                if (result && result['count'] && result['count'] === 1) {
                    this.notify('success', 'Deleted ' + this.entity.label, eid);
                    this.refreshData();
                } else {
                    this.notify('error', 'Delete ' + this.entity.label, JSON.stringify(result));
                }
            }));
    }

    submitRecord(entityRecord): void {
        this.formErrors = [];
        this.formValid = true;
        this.subscriptions.push(this._EntityfieldApi.validateRecord(entityRecord, this.entityid)
            .subscribe((result) => {
                if (result && result.response && result.response.length > 0) {
                    this.formValid = false;
                    this.formErrors = result.response;
                    for (let i = 0; i < this.formErrors.length; i++) {
                        let errorField = this.formErrors[i].field;
                        let errorKey = this.formErrors[i].error;
                        let error = {};
                        error[errorKey] = true;
                        if (this.form.controls[errorField] && typeof this.form.controls[errorField].markAsTouched === 'function') {
                            this.form.controls[errorField].markAsTouched();
                        }
                        this.form.controls[errorField].setErrors(error);
                    }
                }
                if (this.formValid) {
                    this.patchOrCreateEntity(entityRecord);
                } else {
                    this.notify('error', 'Invalid Data', 'Please Correct & Submit');
                }
            }));
    }

    patchOrCreateEntity(entityRecord): void {

        // Save or Create Entity Record
        let entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = this.entityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (let i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                let dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null);
                if (dateStr) {
                    entityRecordforSave.data[this.entityDataFields[i].name] = dateStr;
                }
            }
        }

        if (!this.entityrecordid) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;
            entityRecordforSave.appId = this.currentuser.appId;

            this.subscriptions.push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
                .subscribe((newrecord: Entityrecord) => {
                    this.entityRecord = newrecord;
                    let label = this.entityRecord.id;
                    if (this.entityRecord.data && this.entityRecord.data.name) {
                        label = this.entityRecord.data.name;
                    }
                    this.notify('success', 'Created ' + this.entity.label, label);
                    this.refreshData();
                }));
        } else {
            this.subscriptions.push(this._EntityrecordApi.patchAttributes(this.entityrecordid, entityRecordforSave)
                .subscribe((updatedrecord: Entityrecord) => {
                    this.entityRecord = updatedrecord;
                    var label = this.entityRecord.id;
                    if (this.entityRecord.data && this.entityRecord.data.name)
                        label = this.entityRecord.data.name;
                    this.notify('success', 'Created ' + this.entity.label, label);
                    this.refreshData();
                }));
        }
    }

    refreshData(): void {
        this.hideEditModal();
        this.hideNewModal();

        // Grid list works both for entity id as well as entitytype
        let entityFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
        entityFilter.where['appId'] = this.currentuser.appId;

        if (this.inputentityid)
            entityFilter.where['id'] = this.inputentityid;
        if (this.entitytype)
            entityFilter.where['name'] = this.entitytype;

        let recordFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };

        this.subscriptions.push(this._EntityApi.getRecordsforEntity(entityFilter, recordFilter)
            .subscribe((data) => {
                if (data && data.response && data.response.status && data.response.status === 'ok') {
                    let details = data.response;
                    this.entity = details.entity;
                    this.notify('info', 'Loaded Records', this.entity.label);
                    this.entityid = details.entity.id;
                    this.records = details.records;
                    this.entityFormFields = details['formfields'];
                    this.setsearchlayout(details['datacolumns'], details['searchlayouts']);
                    this.onChangeTable(this.config);
                } else {
                    this.clearupdetails();
                    console.log('Entity Not Loaded: ' + JSON.stringify(entityFilter));
                    this.notify('error', 'Entity', 'Not Loaded');
                    this.onChangeTable(this.config);
                }
            }));
    }

    clearupdetails() {
        this.showError = true;
        delete this.entity;
        delete this.entityid;
        delete this.records;
        delete this.entityFormFields;
        delete this.entityDataFields;
        delete this.columns;
        delete this.rows;
    }

    setsearchlayout(datacolumns, searchlayouts) {
        let fields;
        let defaultSortField;
        let defaultSortType;
        let searchLayout;
        if (searchlayouts && searchlayouts.length && searchlayouts.length > 0) {
            if (this.searchlayoutid) {
                let searchl = _.find(searchlayouts, { id: this.searchlayoutid })
                if (searchl) {
                    searchLayout = searchl;
                }
            } else {
                searchLayout = searchlayouts[0];
            }

        }
        if (searchLayout) {
            fields = searchlayouts[0].fields;
        }
        if (searchLayout && searchLayout.defaultsort && searchLayout.defaultsort[0]) {
            defaultSortField = searchLayout.defaultsort[0];
        }
        if (searchLayout && searchLayout.defaultsorttype) {
            defaultSortType = searchLayout.defaultsorttype;
        }

        this.columns = [];
        //Leave out the first 2 fields as they are the edit icons
        for (let i = 0; i < datacolumns.length; i++) {
            let datacolumn = { title: '', name: '' };
            if (!this.sortable) { datacolumn['sort'] = false; }
            datacolumn.title = datacolumns[i].headerName;
            datacolumn.name = datacolumns[i].field ? datacolumns[i].field : datacolumns[i].id;

            if (defaultSortField && defaultSortType && defaultSortField === datacolumns[i].id) {
                datacolumns[i].sort = 'asc';
            }

            if (fields && _.indexOf(fields, datacolumns[i].id) > -1) {
                this.columns.push(datacolumn);
            }
        }
        this.config['sorting']['columns'] = this.columns;
    }

    checkforDateColumn(column) {
        if (column.fieldtype === 'dateandtime' || column.fieldtype === 'date') {
            return true;
        } else {
            return false;
        }
    }

    resetForm(): void {
        if (this.form && this.form['subscriptions']) {
            this.form['subscriptions'].forEach(s => { s.unsubscribe(); });
        }
        this.form = this.fb.group({});
        this.form['subscriptions'] = [];
    }

    showNewModal(): void {
        this.entityRecord = {};
        if (this.parentId) {
            this.entityRecord['parentId'] = this.parentId;
        }
        this.entityrecordid = null;
        this.formfields = _.cloneDeep(this.entityFormFields);
        this.initialFormData = _.cloneDeep(this.entityRecord);
        this.populateformfields();
        this.newModal.show();
    }

    hideNewModal(): void {
        this.resetForm();
        this.newModal.hide();
    }

    showEditModal(selectedEntityRecord): void {
        this.subscriptions.push(this._EntityrecordApi.findByIdforEdit(selectedEntityRecord.id)
            .subscribe((record) => {
                if (record && record['response']) {
                    if (record['response']['record'] && record['response']['record']['data']) {
                        this.entityRecord = _.cloneDeep(record['response']['record']['data']);
                    } else {
                        this.entityRecord = {};
                    }
                    if (record['response']['formfields']) {
                        this.entityFormFields = record['response']['formfields'];
                    }
                    this.formfields = _.cloneDeep(this.entityFormFields);

                    this.entityrecordid = selectedEntityRecord.id;
                    this.entityRecord.id = selectedEntityRecord.id;
                    this.initialFormData = _.cloneDeep(this.entityRecord);
                    this.populateformfields();
                    this.editModal.show();
                } else {
                    console.log('ERROR - Loading Record ' + selectedEntityRecord.id);
                    this.notify('error', 'Record', 'Not Loaded; Please refresh');
                }
            }));
    }

    hideEditModal(): void {
        this.resetForm();
        this.editModal.hide();
    }

    populateformfields() {
        console.log(this.formfields);
        this.formfields.forEach(ff => {
            this.populateFormGroup(ff);
        });
        console.log(this.formfields);
    }

    populateFormGroup(formgroup) {
        if (formgroup.type === 'repeatedsection') {
            formgroup.templateOptions['parentmodel'] = this.initialFormData;
        } else if (!formgroup.type && Array.isArray(formgroup.fieldGroup) && formgroup.fieldGroup.length > 0) {
            formgroup.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        } else if (!formgroup.type && formgroup.fieldArray
            && Array.isArray(formgroup.fieldArray.fieldGroup)
            && formgroup.fieldArray.fieldGroup.length > 0) {
            formgroup.fieldArray.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        }
    }

    // public showPeekModal(selectedEntityRecord): void {
    //     //Get the record first
    //     this.subscriptions.push(this._EntityrecordApi.findById(selectedEntityRecord.id)
    //         .subscribe((record: Entityrecord) => {
    //             this.entityRecord = record.data;
    //             this.entityRecord.id = selectedEntityRecord.id;
    //             this.entityrecordid = selectedEntityRecord.id;
    //             this.peekModal.show();
    //         }));

    // }

    // public hidePeekModal(): void {
    //     this.peekModal.hide();
    // }

    viewEntity(): void {
        //Go to the View entity page
    }

    updateValidations(formfields) {
        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];
            let fieldType = formField.type;
            let fieldSubType = '';
            let validators = [];

            if (formField.templateOptions.type) {
                fieldSubType = formField.templateOptions.type;
            } else {
                fieldSubType = 'text';
            }
            switch (fieldType) {
                case 'input-field':
                    switch (fieldSubType) {
                        case 'email':
                            validators.push(ValidationService.emailValidator);
                            break;
                        case 'phone':
                            validators.push(ValidationService.phoneValidator);
                            break;
                        case 'default':
                            break;
                    }
                    break;
                case 'geolocation':
                    validators.push(ValidationService.geolocationValidator);
                    break;
                case 'default':
                    break;
            }
            formField['validators'] = { validation: Validators.compose(validators) };

            if (this.parentId && formField.key === "parentId") {
                formField.templateOptions.disabled = true;
            }
        }
        return formfields;
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        let columnNames = columnName.split('.');
        if (columnNames.length === 1) {
            return data.sort((previous: any, current: any) => {
                if (previous[columnName] > current[columnName]) {
                    return sort === 'desc' ? -1 : 1;
                } else if (previous[columnName] < current[columnName]) {
                    return sort === 'asc' ? -1 : 1;
                }
                return 0;
            });
        } else {
            return data.sort((previous: any, current: any) => {
                if (previous[columnNames[0]][columnNames[1]] > current[columnNames[0]][columnNames[1]]) {
                    return sort === 'desc' ? -1 : 1;
                } else if (previous[columnNames[0]][columnNames[1]] < current[columnNames[0]][columnNames[1]]) {
                    return sort === 'asc' ? -1 : 1;
                }
                return 0;
            });
        }
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                // if (item[column.name].toString().match(this.config.filtering.filterString)) {
                flag = true;
                // }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any): any {
        if (config.filtering) { Object.assign(this.config.filtering, config.filtering); }
        if (config.sorting) { Object.assign(this.config.sorting, config.sorting); }

        // let filteredData = this.changeFilter(this.records, this.config);
        // let sortedData = this.changeSort(filteredData, this.config);
        let sortedData = this.changeSort(this.records, this.config);
        this.rows = this.updateDisplays(sortedData);
        this.length = sortedData.length;
    }

    updateDisplays(records: any): any {
        if (records && records.length) {
            for (let i = 0; i < records.length; i++) {
                if (records[i] && records[i].data) {
                    for (let key in records[i].data) {
                        if (records[i].data[key] && records[i].data[key].display && records[i].data[key].value) {
                            records[i].data[key] = records[i].data[key].display;
                        }
                        if (!records[i].data[key]) { records[i].data[key] = ''; }
                    }
                }
            }
        }
        return records;
    }

    onCellClick(record: any): any {
        console.log(record);
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/table-display/table-display.component.ts